module.exports = __webpack_public_path__ + "img/frame (182).941f3f68.jpg";